import { render, staticRenderFns } from "./Residentials.vue?vue&type=template&id=ddc8f7d2"
import script from "./Residentials.vue?vue&type=script&lang=js"
export * from "./Residentials.vue?vue&type=script&lang=js"
import style0 from "./Residentials.vue?vue&type=style&index=0&id=ddc8f7d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports